import React, { useState, useEffect, useCallback } from 'react';
import { WBFlex, WBIcon } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import debounce from 'lodash/debounce';
import { InputAdornment, OutlinedInput } from '@mui/material';

interface SearchClientInputProps {
  onSearchChange: (search: string) => void;
  initialValue?: string;
  debounceTime?: number;
}

export const DebouncedSearchClientInput: React.FC<SearchClientInputProps> = ({
  onSearchChange,
  initialValue = '',
  debounceTime = 300,
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState<string>(initialValue);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      onSearchChange(value);
    }, debounceTime),
    [onSearchChange, debounceTime]
  );

  useEffect(() => {
    if (initialValue) {
      onSearchChange(initialValue);
    }
  }, []);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <WBFlex sx={{ minWidth: '500px' }}>
      <OutlinedInput
        sx={{
          flex: 1,
        }}
        startAdornment={
          <InputAdornment position="start">
            <WBIcon name="Search" size="small" />
          </InputAdornment>
        }
        placeholder={t('searchClient', { ns: 'clients' })}
        value={searchValue}
        onChange={handleSearchChange}
      />
    </WBFlex>
  );
};
